import './Table.css';
import { TableUIProp } from './TableUI';
const TableUI = (props: TableUIProp) => {

    return (
        <div className="wrapper">
            <div className="table">
                <div className="row-td header">
                    {(props.column || []).map(item => {
                        return (<div className="cell" style={{ width: item.width, textAlign: ((item.headerAlign || "center")), ...item.style }}> {item.name}</div>)
                    })}
                </div>
                {(props.row || []).length > 0 &&
                    (props.row || []).map(row => {
                        return (
                            <div className="row-td tbody">
                                {(props.column || []).map(item => {
                                    return (<div className="cell" data-title={item.name} style={{ textAlign: (item.cellAlign || "center") }}>
                                        {item.renderCell ? item.renderCell(row) : row[item.id] || ""}
                                    </div>)
                                })}
                            </div>
                        )
                    })
                }

            </div>
            {(props.row || []).length <= 0 &&
                <div className="not-found-data">
                    ไม่พบข้อมูล
                </div>
            }
        </div>
    )
}
export default TableUI;